import { render, staticRenderFns } from "./CustomerSources.vue?vue&type=template&id=28c4f69a"
import script from "./CustomerSources.vue?vue&type=script&lang=js"
export * from "./CustomerSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports